import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Paper, TableBody, TableCell, TableRow } from "@mui/material";
import styled from "@emotion/styled";

import Pagination from "Components/Common/BaseTable/Pagination";
import { usePagination } from "Components/Common/BaseTable";
import { StyledTable, StyledTableCell, StyledTableHead } from "./style";

const RECORDS_PER_PAGE = 10;

const StyledTableContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "maxHeight",
})`
  max-height: ${({ maxHeight }) => maxHeight ?? "unset"};
  overflow-y: auto;
  .MuiPaper-root {
    overflow-x: scroll;
  }
`;

const ConsumerAndMeteringStatusTable = ({ data, keys, maxHeight, t }) => {
  const paginate = usePagination();
  const [rowData, setRowData] = useState([]);
  const { page, setTotalPages } = paginate;
  const [parentKey, childKey, ...subChildKey] = keys;

  const headerName = data?.[0]?.[parentKey]?.[0]?.[childKey]?.map(
    (item) => item[subChildKey[0]]
  );
  const tableData = data?.[0]?.[parentKey] || [];

  useEffect(() => {
    if (tableData.length) {
      setTotalPages(Math.ceil(tableData.length / RECORDS_PER_PAGE));
      const rowData =
        tableData.slice(
          RECORDS_PER_PAGE * (page - 1),
          RECORDS_PER_PAGE * page
        ) || [];
      setRowData(rowData);
    }
  }, [page, RECORDS_PER_PAGE, setTotalPages, tableData, data]);

  return (
    <>
      <StyledTableContainer maxHeight={maxHeight}>
        <StyledTable>
          <StyledTableHead>
            <TableRow>
              <StyledTableCell rowSpan={2}>{t("Month")}</StyledTableCell>
              {headerName?.map((header, index) => (
                <React.Fragment key={index}>
                  <StyledTableCell align="center">
                    {t(`${header}`)}
                  </StyledTableCell>
                </React.Fragment>
              ))}
              <StyledTableCell rowSpan={2}>{t("Total Count")}</StyledTableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {tableData.length ? (
              rowData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.month}</TableCell>
                  {item?.[childKey]?.map(({ count }, index) => (
                    <>
                      <TableCell key={index} align="center">
                        {count}
                      </TableCell>
                    </>
                  ))}
                  <TableCell>{item.totalCount}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableData.length} className="text-center">
                  {t("No Data Available")}!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {!!tableData.length && <Pagination paginate={paginate} />}
    </>
  );
};

ConsumerAndMeteringStatusTable.propTypes = {
  data: PropTypes.array,
  keys: PropTypes.array,
  maxHeight: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(ConsumerAndMeteringStatusTable);
